import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen} from '@fortawesome/free-solid-svg-icons'

export const ImageButton = ({ images, setImages, setShowImageBtn}) => {

  const handleShow = () => {
    setImages(images)
    setShowImageBtn(true)
  };

    return(
        <React.Fragment>
           <div className="custom-button">
            <FontAwesomeIcon className="image-button-icon" icon={faFolderOpen} onClick={() => handleShow()} ></FontAwesomeIcon>
           </div>
        </React.Fragment>
    )
}